<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<!-- <template src="./Bills.html">-->
<template>
  <div>
    <vx-card class="mb-2">
      <vs-table
        id="tbl1"
        ref="tbl1"
        :data="roles2"
        class="table-dark-inverted"
        @selected="selected"
        pagination 
        :max-items="pageSize"
        :currentPage="pageNo"
      >
        <template slot="header">
          <div class="vx-row mb-2 w-full">
            <div class="vx-col sm:w-2/3 flex-inline">
              <div class="vx-row mb-2">
                <div class="vx-col">
                  <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                      <div
                        class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                      >
                        <span class="mr-2">
                          {{ (pageNo-1)*pageSize +1}}
                          -
                          {{ (pageNo)*pageSize>totalCount?totalCount:(pageNo)*pageSize }}
                          از {{ totalCount }}
                        </span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                      </div>
                      <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="SetPageSize(5)">
                          <span>5</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(10)">
                          <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(20)">
                          <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(50)">
                          <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(100)">
                          <span>100</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(150)">
                          <span>150</span>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-col sm:w-1/3 flex-inline">
              <vs-button
                style="float: left;"
                @click="new_()"
                class="mx-3"
                color="dark"
                type="border"
                icon-pack="feather"
                icon="icon-plus"
              >جدید</vs-button>
            </div>
          </div>
        </template>
        <template slot="thead">
          <vs-th>عنوان</vs-th>
          <vs-th>توضیحات</vs-th>
          <vs-th></vs-th>
          <vs-th></vs-th>
          <!-- <vs-th></vs-th> -->
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <span>{{tr.title}}</span>
            </vs-td>
            <vs-td>
              <span>{{tr.description}}</span>
            </vs-td>
            <vs-td class="pl-0 pr-0">
              <vs-chip v-if="tr.active" color="success">فعال</vs-chip>
              <vs-chip v-if="!tr.active" color="danger">غیرفعال</vs-chip>
            </vs-td>
            <!-- <vs-td>
              <a @click="manageRoles(tr.id,tr.userName)">مدیریت نقشها</a>
            </vs-td>-->
            <vs-td>
              <vs-dropdown>
                <a class="flex items-center" href.prevent>
                  عملیات
                  <i class="material-icons">expand_more</i>
                </a>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="edit(tr.id,tr.title)">ویرایش</vs-dropdown-item>
                  <vs-dropdown-item @click="confirmDelete(tr.id,tr.title)">حذف</vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <create-or-edit-department ref="createOrEditDepartment1" @success="fillTable()"></create-or-edit-department>
  </div>
</template>
<style>
.nav-transacttions > .vs-popup {
  width: 100%;
}
</style>
<script>
import vSelect from "vue-select";
import { MerchantStatus, Colors } from "@/enums.js";
import CreateOrEditDepartment from "./CreateOrEditDepartment.vue";
export default {
  props: {
    transactions: {}
  },
  components: {
    "v-select": vSelect,
    CreateOrEditDepartment,
  },
  data() {
    return {
      roles2: [],
      Colors,
      totalCount: 1,
      pageSize: 20,
      pagesCount: 1,
      pageNo: 1,
      selectedUserId: null,
      filter: "",
      permission: ""
    };
  },
  computed: {},
  methods: {
    fillTable() {
      let loading = this.$vs.loading();
      this.$http
        .get("/api/services/app/Departments/GetAll")
        .then(response => {
          this.roles2 = response.data.result;
          this.$vs.loading.close();
          this.totalCount=this.roles2.length;
        }) //end success
        .catch(error => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
    clear() {
      this.permission = "";
      this.filter = "";
    },
    SetPageSize(val) {
      this.pageSize = val;
      this.pageNo = 1;
    },
    new_() {
      this.$refs.createOrEditDepartment1.show();
    },
    edit(userId, shopName) {
      this.$refs.createOrEditDepartment1.show(userId, shopName);
    },
    confirmDelete(id, name) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `تاییدیه حذف`,
        text: `آیا از حذف دپارتمان "${name}" مطمئن هستید؟`,
        accept: () => {
          this.delete_(id);
        },
        acceptText: "تایید",
        cancelText: "انصراف"
      });
    },
    delete_(id) {
      let loading = this.$vs.loading();
      let payload = {
        params: {
          id: id
        }
      };
      this.$http
        .delete("/api/services/app/Departments/Delete", payload)
        .then(response => {
          if (response.data.success == true) {
            this.fillTable();
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "دپاتمان با موفقیت حذف شد"
            });
          }
          this.$vs.loading.close();
        }) //end success
        .catch(error => {
          this.$vs.loading.close();
        }); //end http
    },
    selected(tr) {
      //this.showTransaction(tr.transaction.id);
    },
  },
  mounted() {
    this.fillTable();
  }
};
</script>
